import React, { useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PeopleIcon from "@mui/icons-material/People";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import AppsIcon from "@mui/icons-material/Apps";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

export default function BuildDepartmentDrawer() {
  const { businessDomainId, businessUnitId, departmentId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const [open, setOpen] = useState(false);

  const basePath = `/build/${businessDomainId}/business-units/${businessUnitId}/departments/${departmentId}`;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const items = [
    {
      label: t("build.department.action.list.title"),
      icon: <FormatListBulletedIcon />,
      path: `${basePath}/actions`,
    },
    {
      label: t("member.list.title"),
      icon: <PeopleIcon />,
      path: `${basePath}/members`,
    },
    {
      label: t("build.department.member.move.company.title"),
      icon: <TransferWithinAStationIcon />,
      path: `${basePath}/members/move/company`,
    },
    {
      label: t("build.department.member.move.market.title"),
      icon: <TransferWithinAStationIcon />,
      path: `${basePath}/members/move/market`,
    },
    {
      label: t("build.department.application.list.title"),
      icon: <AppsIcon />,
      path: `${basePath}/applications`,
    },
    {
      label: t("build.department.partner.list.title"),
      icon: <HandshakeIcon />,
      path: `${basePath}/partners`,
    },
  ];

  return (
    <>
      <IconButton
        size="small"
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleOpen}
        sx={{ mr: 1 }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        variant="temporary"
        anchor="left"
        open={open}
        onClose={handleClose}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 0.5 }}>
          <IconButton onClick={handleClose}>
            <ChevronLeftIcon />
          </IconButton>
        </Box>
        <Divider />
        <List sx={{ width: 260 }}>
          {items.map((item) => (
            <ListItem
              key={item.path}
              button
              onClick={() => go(item.path)}
              sx={{ cursor: "pointer" }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
